import { render, staticRenderFns } from "./SaleType.vue?vue&type=template&id=6f030c5a&"
import script from "./SaleType.vue?vue&type=script&lang=js&"
export * from "./SaleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports